export const GROUP_ROLE = 'AWARDED_GROUP_AVERAGE';
export const AWARD_ROLE = 'AWARDED_TOTAL_AVERAGE';
export const PREDECESSOR_SESSION_GROUP_ROLE =
  'AWARDED_TOTAL_AVERAGE_PREDECESSOR_SESSION';
class JurorStatistic {
  constructor(
    role,
    jurorId,
    firstname,
    lastname,
    profilePictureUrl,
    decidedEvaluationCount,
    totalEvaluationCount,
    totalPointsFromAllDecidedEvaluations
  ) {
    this.role = role;
    this.jurorId = jurorId;
    this.firstname = firstname;
    this.lastname = lastname;
    this.profilePictureUrl = profilePictureUrl;
    this.decidedEvaluationCount = decidedEvaluationCount;
    this.totalEvaluationCount = totalEvaluationCount;
    this.totalPointsFromAllDecidedEvaluations = totalPointsFromAllDecidedEvaluations;
  }

  static from = (jurorStatistic) => {
    return new JurorStatistic(
      jurorStatistic.role,
      jurorStatistic.jurorId,
      jurorStatistic.firstname,
      jurorStatistic.lastname,
      jurorStatistic.profilePictureUrl,
      jurorStatistic.decidedEvaluationCount,
      jurorStatistic.totalEvaluationCount,
      jurorStatistic.totalPointsFromAllDecidedEvaluations
    );
  };

  static of = (jurorStatistics) => {
    return jurorStatistics?.map((statistic) => JurorStatistic.from(statistic));
  };
}

class EvaluationStatistic {
  constructor(
    jurors,
    numScoreAlerts,
    numSubmissionsWithSuggestedForNomination,
    numSubmissionsWithNomination,
    numEvaluationsWithComment,
    numEvaluationsWithNotDiscussedComment,
    numEntriesWithNotDiscussedComment,
    numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneHalve,
    numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneThird
  ) {
    this.jurors = jurors;
    this.numScoreAlerts = numScoreAlerts;
    this.numSubmissionsWithSuggestedForNomination =
      numSubmissionsWithSuggestedForNomination;
    this.numSubmissionsWithNomination = numSubmissionsWithNomination;
    this.numEvaluationsWithComment = numEvaluationsWithComment;
    this.numEvaluationsWithNotDiscussedComment =
      numEvaluationsWithNotDiscussedComment;
    this.numEntriesWithNotDiscussedComment = numEntriesWithNotDiscussedComment;
    this.numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneHalve =
      numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneHalve;
    this.numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneThird =
      numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneThird;
  }

  static from = (evaluationStatistic) => {
    return new EvaluationStatistic(
      JurorStatistic.of(evaluationStatistic.jurors),
      evaluationStatistic.numScoreAlerts,
      evaluationStatistic.numSubmissionsWithSuggestedForNomination,
      evaluationStatistic.numSubmissionsWithNomination,
      evaluationStatistic.numEvaluationsWithComment,
      evaluationStatistic.numEvaluationsWithNotDiscussedComment,
      evaluationStatistic.numEntriesWithNotDiscussedComment,
      evaluationStatistic.numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneHalve,
      evaluationStatistic.numFullyDecidedSubmissionsWithPointsAboveSessionMedianOneThird
    );
  };

  static of = (evaluationStatistics) => {
    return evaluationStatistics?.map((statistic) =>
      EvaluationStatistic.from(statistic)
    );
  };

  static fetchForGroup = async (jurorGroupId) => {
    return fetch(`/if-api/jury-v2/jurorGroup/${jurorGroupId}/awarded`)
      .then((response) => response.json())
      .then((statistics) => EvaluationStatistic.from(statistics))
      .catch((err) => console.error(err));
  };
}

export default EvaluationStatistic;
